import React, { createContext, FC, useCallback, useContext, useState, ReactNode } from 'react'
import { CreditCard } from '@afterpaytouch/portal-api'

// @ts-ignore: OPERATION BLEED STOPPER
const noop = (): void => null

export enum ReportCardCancellationSteps {
  Initial,
  Decline,
  SelectCard,
  Confirm,
}

export interface ReportCardCancellationResult {
  success: boolean
  error: boolean
  message?: string
}

export interface ReportCardCancellationContextProps {
  step: ReportCardCancellationSteps
  setStep: (step: ReportCardCancellationSteps) => void
  resetState: () => void
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  closeModal: () => void
  creditCards: CreditCard[]
  setCreditCards: (creditCards: CreditCard[]) => void
  selectedCardIds: number[]
  setSelectedCardIds: (ids: number[]) => void
  refetchCard: () => void
}

export const reportCardCancellationContextDefaultValue: ReportCardCancellationContextProps = {
  // @ts-ignore: OPERATION BLEED STOPPER
  step: null,
  setStep: noop,
  resetState: noop,
  isLoading: false,
  setIsLoading: noop,
  closeModal: noop,
  creditCards: [],
  setCreditCards: noop,
  selectedCardIds: [],
  setSelectedCardIds: noop,
  refetchCard: noop,
}

export const ReportCardCancellationModalContext = createContext<ReportCardCancellationContextProps>(reportCardCancellationContextDefaultValue)

export const useReportCardCancellationModalContext = (): ReportCardCancellationContextProps => {
  return {
    ...useContext(ReportCardCancellationModalContext),
  }
}

export interface ReportCardCancellationModalProviderProps {
  defaultPaymentMethod?: CreditCard
  closeModal: () => void
  refetchCard: () => void
  children: ReactNode
}

export const ReportCardCancellationModalProvider: FC<ReportCardCancellationModalProviderProps> = ({
  children,
  defaultPaymentMethod,
  closeModal,
  refetchCard,
}) => {
  const [step, setStep] = useState<ReportCardCancellationSteps>(ReportCardCancellationSteps.Initial)
  const [isLoading, setIsLoading] = useState(false)
  const [creditCards, setCreditCards] = useState([])
  // @ts-ignore: OPERATION BLEED STOPPER
  const [selectedCardIds, setSelectedCardIds] = useState([defaultPaymentMethod.id])

  const resetState = useCallback(() => {
    setStep(ReportCardCancellationSteps.Initial)
    setIsLoading(false)
    setCreditCards([])
    setSelectedCardIds([])
  }, [])

  const value = {
    step,
    setStep,
    resetState,
    isLoading,
    setIsLoading,
    closeModal,
    creditCards,
    setCreditCards,
    selectedCardIds,
    setSelectedCardIds,
    refetchCard,
  }
  // @ts-ignore: OPERATION BLEED STOPPER
  return <ReportCardCancellationModalContext.Provider value={value}>{children}</ReportCardCancellationModalContext.Provider>
}
